import type {TFunction} from 'i18next'
import type {AttentionBucket, AttentionSignal} from '@/hooks/inci/consola/use-admin'
import {formatShortDate} from '@/lib/risk'

export type SignalTone = 'red' | 'amber'

export function signalTone(bucket: AttentionBucket): SignalTone {
  return bucket === 'critico_ahora' ? 'red' : 'amber'
}

function signalValues(signal: AttentionSignal) {
  return {
    count: signal.count ?? 0,
    date: signal.deadline ? formatShortDate(signal.deadline) : '',
  }
}

export function signalChip(t: TFunction, signal: AttentionSignal): string {
  return t(`admin.signals.${signal.kind}.chip`, signalValues(signal))
}

export function signalRow(t: TFunction, signal: AttentionSignal): {label: string; detail: string} {
  const values = signalValues(signal)
  return {
    label: t(`admin.signals.${signal.kind}.row`, values),
    detail: t(`admin.signals.${signal.kind}.detail`, {...values, defaultValue: ''}),
  }
}
